import { parseJSONText } from "./utils";

const JsonText = ({ value }) => {
  const parsed = parseJSONText(value);
  if (!parsed) return <span className="opacity-60">-</span>;

  if (typeof parsed === "string") {
    return <span className="break-all">{parsed}</span>;
  }

  return (
    <pre className="text-xs whitespace-pre-wrap break-all opacity-80">
      {JSON.stringify(parsed, null, 2)}
    </pre>
  );
};

export default JsonText;
